import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import GerarAuditoriaDto from "model/auditoria5s/gerar/GerarAuditoriaDto";
import GerarAuditoriaItemDto from "model/auditoria5s/gerar/GerarAuditoriaItemDto";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";

type Props = {
    visible: boolean;
    onConfirm: () => void;
    onHide: () => void;
}

const periodicidadeService = new PeriodicidadeService();
const auditoriaService = new AuditoriaService();
export default function ModalSortearSetoresParaAuditoria(props: Props) {

    const { msgAlerta, msgErro } = useToastContext();

    const [setoresSelecionados, setSetoresSelecionados] = useState<Setor[]>([]);
    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);
    const [setoresSorteados, setSetoresSorteados] = useState<Setor[]>([]);
    const [numeroDeSetores, setNumeroDeSetores] = useState<number>(0);

    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);
    const [screenIndex, setScreenIndex] = useState(0);

    const [dados, setDados] = useState<GerarAuditoriaDto>(new GerarAuditoriaDto());

    useEffect(() => {
        if (props.visible) {
            auditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
            auditoriaService.getUsuariosDisponiveis().then(response => setUsuariosDisponiveis(response)).catch(() => setUsuariosDisponiveis([]));
        }
    }, [props.visible]);

    useEffect(() => {
        console.log(dados);
    }, [dados]);

    function sortearSetores() {
        if (!setoresSelecionados || setoresSelecionados.length === 0) {
            msgAlerta("Atenção", "Selecione pelo menos um setor para realizar o sorteio.");
            return;
        }

        if (!numeroDeSetores) {
            msgAlerta("Atenção", "Informe a quantidade de setores a serem sorteados.");
            return;
        }

        if (numeroDeSetores <= 0) {
            msgAlerta("Atenção", "A quantidade de setores deve ser maior que zero.");
            return;
        }

        if (numeroDeSetores > setoresSelecionados.length) {
            msgAlerta(
                "Atenção",
                "A quantidade de setores a serem sorteados não pode ser maior que a quantidade de setores selecionados."
            );
            return;
        }
        auditoriaService.sortearSetores(numeroDeSetores, setoresSelecionados).then(response => {
            const itens: GerarAuditoriaItemDto[] = [];
            setSetoresSorteados(response);
            //Se o setor tiver apenas um plano de auditoria, já adiciona ele na lista de itens
            response.forEach(setor => {
                if (setor.planos.length === 1) {
                    const plano = setor.planos[0];
                    itens.push({ ligacao: plano, usuario: plano.auditor });
                }
            });
            setDados({ ...dados, itens: itens });
            setScreenIndex(1);
        }).catch(err => {
            if (err && err.data && err.data.message) {
                msgErro("Erro", err.data.message);
            } else {
                msgErro("Erro", "Erro ao sortear setores");
            }
            console.log(err);
        });
    }

    function validar() {
        if (dados.itens.length < 1) {
            msgAlerta("Planos insuficientes", "Seleciona pelo menos um plano");
            return false;
        }

        if (!dados.sortearUsuarios) {
            for (const item of dados.itens) {
                if (!item.usuario) {
                    msgAlerta("Usuário não selecionado", "Selecione um usuário para cada plano");
                    return false;
                }
            }
        }

        for (const setor of setoresSorteados) {
            const possuiItem = dados.itens.some(item => item.ligacao?.setor?.id === setor.id);

            if (!possuiItem) {
                msgAlerta("Setor sem plano", `O setor "${setor.nome}" não possui nenhum plano associado.`);
                return false;
            }
        }

        return true;
    }

    function gerarAuditorias() {
        if (!validar()) {
            return;
        }

        auditoriaService.gerarNovaAuditoria(dados).then(e => {
            props.onConfirm();
        }).catch(err => {
            if (err && err.data && err.data.message) {
                falhaGerar(err.data.message);
            } else {
                falhaGerar("Erro ao gerar auditoria");
            }

            console.log(err);
        });
    }

    function falhaGerar(msg: string) {
        msgErro("Erro", msg);
    }

    const screenZeroButtons = () => {
        return (
            <>
                <Button label="Sortear" className="p-button-info" onClick={() => {
                    sortearSetores();
                }} />
            </>
        )
    }

    const screenOneButtons = () => {
        if (dados.sortearUsuarios) {
            return (
                <>
                    <Button label="Voltar" className="p-button-secondary" onClick={() => {
                        setScreenIndex(0);
                    }} />
                    <Button label="Gerar" className="p-button-info" onClick={() => {
                        gerarAuditorias();
                    }} />
                </>
            )
        }
        return (
            <>
                <Button label="Voltar" className="p-button-secondary" onClick={() => {
                    setScreenIndex(0);
                }} />
                <Button label="Próximo" className="p-button-info" onClick={() => {
                    for (const setor of setoresSorteados) {
                        const possuiItem = dados.itens.some(item => item.ligacao?.setor?.id === setor.id);

                        if (!possuiItem) {
                            msgAlerta("Setor sem plano", `O setor "${setor.nome}" não possui nenhum plano associado.`);
                            return;
                        }
                    }
                    setScreenIndex(2);
                }} />
            </>
        )
    }

    const screenTwoButtons = () => {
        return (
            <>
                <Button label="Voltar" className="p-button-secondary" onClick={() => {
                    setScreenIndex(1);
                }} />
                <Button label="Gerar" className="p-button-info" onClick={() => {
                    gerarAuditorias();
                }} />
            </>
        )
    }

    //tela escolher setores para sortear
    const screenZero = () => {
        return (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

                <div className="row">
                    <div className="col-sm-12">
                        <Label className="col-sm-12">Quantidade de setores a serem sorteados</Label>
                        <InputNumber
                            value={numeroDeSetores}
                            onValueChange={(e) => setNumeroDeSetores(e.value as number)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <DataTable
                            header='Setores disponíveis'
                            value={setoresDisponiveis}
                            selectionMode='checkbox'
                            selection={setoresSelecionados}
                            onSelectionChange={(e) => setSetoresSelecionados(e.value as Setor[])}
                            dataKey="id"
                            tableStyle={{ minWidth: '50rem' }}
                            emptyMessage="Nenhum registro encontrado"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="nome" header="Nome"></Column>
                        </DataTable>

                    </div>
                </div>
            </div>
        )
    }

    // tela para mostrar setores sorteados e escolher os planos de auditoria
    // define se vai sortear os usuarios ou se vai escolher manualmente
    const screenOne = () => {
        return (
            <div>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                    <Checkbox
                        checked={dados.sortearUsuarios} onChange={(e) => setDados({ ...dados, sortearUsuarios: e.checked || false })}
                    />
                    <Label className="col-sm-12" >Sortear usuários</Label>

                </div>
                <div className="row">
                    <div className="col-sm-12">

                        <DataTable
                            header='Setores disponíveis'
                            value={setoresSorteados}
                            dataKey="id"
                            tableStyle={{ minWidth: '50rem' }}
                            expandedRows={setoresSelecionados}
                            rowExpansionTemplate={expendedRowTemplate}
                            emptyMessage="Nenhum registro encontrado"
                        >
                            <Column field="nome" header="Nome"></Column>
                        </DataTable>

                    </div>
                </div>
            </div>
        )
    }

    // tela para escolher os usuarios manualmente
    const screenTwo = () => {
        return (
            <div>
                <DataTable
                    header="Selecionar usuários"
                    value={dados.itens}
                    tableStyle={{ minWidth: '50rem' }}
                    emptyMessage="Nenhum Plano de Auditoria selecionado"
                >
                    <Column field="ligacao.setor.nome" header="Setor"></Column>
                    <Column field="ligacao.planoAuditoria.nome" header="Plano"></Column>
                    <Column header="Limite" body={(rowData: GerarAuditoriaItemDto) => {
                        return rowData.ligacao?.limite?.ativa ?
                            rowData.ligacao?.limite.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.ligacao?.limite.tipoPeriodo)?.label
                            : "Inativo"

                    }} />
                    <Column header="Usuário" style={{ width: 200 }} body={(rowData: GerarAuditoriaItemDto) => (
                        <Dropdown
                            style={{ width: "100%" }}
                            dataKey="id"
                            value={rowData.usuario}
                            options={usuariosDisponiveis}
                            optionLabel="nome"
                            onChange={(e) => {
                                rowData.usuario = e.value;
                                setDados({ ...dados });
                            }}
                            filter
                            filterBy="nome"
                        />
                    )} />

                </DataTable>

            </div>
        )
    }

    const expendedRowTemplate = (setor: Setor) => {

        return (
            <div style={{ width: '100%', display: "flex", paddingTop: 10, paddingBottom: 10, justifyContent: "center" }}>
                <div style={{ width: "80%" }} >
                    <Label className="col-sm-12" >Selecione um plano</Label>
                    <div className="col-sm-12">
                        <DataTable
                            emptyMessage="Nenhum registro encontrado"
                            value={setor.planos}
                            selectionMode='radiobutton'
                            selection={dados.itens.map((item: any) => item.ligacao)}
                            onSelectionChange={(e) => {
                                let itens = [...dados.itens];
                                let ligacaoSelecionada = e.value as SetorPlanoAuditoria;

                                // remove todos os itens do setor e adiciona o item selecionado
                                itens = itens.filter(item => item.ligacao?.setor?.id !== setor.id);
                                if (ligacaoSelecionada) {
                                    itens.push({ ligacao: ligacaoSelecionada, usuario: ligacaoSelecionada.auditor });
                                }
                                setDados({ ...dados, itens: itens })
                            }}
                            dataKey="id"
                            tableStyle={{ minWidth: '100%' }}
                        >
                            <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="planoAuditoria.nome" header="Nome"></Column>
                            <Column field="auditor.nome" header="Auditor"></Column>
                            <Column header="Limite" body={(rowData: SetorPlanoAuditoria) => {
                                return rowData.limite?.ativa ?
                                    rowData.limite.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.limite.tipoPeriodo)?.label
                                    : "Inativo"
                            }} />
                        </DataTable>
                    </div>

                </div>
            </div>

        )
    }

    return (
        <Dialog visible={props.visible}
            onHide={() => {
                setSetoresSelecionados([]);
                props.onHide();
            }}
            header="Selecione os setores para gerar Auditoria"
            footer={<div>
                <Button label="Cancelar" className="p-button-danger" onClick={() => {
                    setSetoresSelecionados([]);
                    props.onHide();
                }} />
                {screenIndex == 0 && screenZeroButtons()}
                {screenIndex == 1 && screenOneButtons()}
                {screenIndex == 2 && screenTwoButtons()}
            </div>}
        >
            {screenIndex == 0 && screenZero()}
            {screenIndex == 1 && screenOne()}
            {screenIndex == 2 && screenTwo()}
        </Dialog>
    )
}